import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { WebService } from '../services/web.service';

@Injectable({
  providedIn: 'root'
})
export class KnowledgeBaseService {
  knowledgeBaseList: any=[];
  metadata: any;
  tagMetaData: any;
  tagList: any;
  tagFilterList: any[];
  resource_category: any;

  constructor(
    private webapi: WebService,
   
) { }

  getKnowledgeBases() {
    return new Promise((resolve, reject) => {
        this.webapi.requestJson('getKnowledgeBase', null)
        .subscribe(
            data => {
                let response = JSON.parse(data.body);
                this.knowledgeBaseList = [...response.data];
                resolve(true)
            },
            error => { return(true) }
        )
    })
  }
  
  getMetadata(){
    return new Promise((resolve, reject) => {
    this.webapi
      .requestJson('getMetaData', {
        metadata: ['resource_category', 'resource_tags'],
      })
      .subscribe(
        (data) => {
          let response = JSON.parse(data.body)
          this.metadata = [response.data ];
          // this.metadata = [...response.data];
        //   this.metadata = cloneDeep(response.data);

          if (this.metadata.resourceTagCategory) {
            this.tagMetaData = this.metadata.resourceTagCategory;
            this.tagList = [...this.tagMetaData];
            this.tagFilterList = [];
            this.tagList.forEach((element) => {
              this.tagFilterList.push({
                text: element.name,
                value: element.tag_id,
                byDefault: false,
              });
            });
          }
          if (this.metadata.resourceCategory) {
            this.resource_category = this.metadata.resourceCategory;
          }
        },
        (error) => {
          // this.spinner.hide();
          var msg = error.headers.get('message');
          //   this.toast.error({
          //     title: "Error",
          //     msg,
          //     theme: 'bootstrap',
          //     timeout: 3000
          //   })
        }
      );
    })
  }


}